import React from "react" 
import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addVisitType } from "service/api"

const defaultValue = {
  name: "",
  color: ""
}

const Addvisit_type = () => {
  const [visit, setVisit] = useState(defaultValue)
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

   useEffect(() => {
            document.title = "Visit Type | Add Visit Type";
          }, []);

  const onValueChange = (e) => {
    setVisit({ ...visit, [e.target.name]: e.target.value })
    setErrors({ ...errors, [e.target.name]: "" }) // clear error when typing
  }

  const validate = () => {
    const tempErrors = {}

    if (!visit.visit || visit.visit.trim() === "") {
      tempErrors.visit = "Visit Type is required"
    }

    setErrors(tempErrors)

    return Object.keys(tempErrors).length === 0
  }

 const handleAddVisitType = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true); // ✅ start loading
    try {
      await addVisitType(visit);
      toast.success("Visit type added successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
      navigate("/visit_type");
    } catch (error) {
      toast.error("Something went wrong.");
      console.error("Error while adding visit type:", error);
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

    
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Visit Type </h4>
            <Link to="/visit_type" className="btn btn-danger">Visit Type</Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Visit Type</Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.visit ? "is-invalid" : ""}`}
                          name="visit"
                          Placeholder="Enter Visit Type"
                          onChange={e => onValueChange(e)}
                        />
                        {errors.visit && (
                          <div className="invalid-feedback">{errors.visit}</div>
                        )}
                      </div>
                    </Col>
                    {/* <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Color
                        </Label>
                        <Input
                          type="color"
                          className="form-control"
                          name="color"
                          onChange={e => onValueChange(e)}
                        />
                      </div>
                    </Col> */}
                  </Row>
                  <div>
                    <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddVisitType}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  Addvisit_type ;
